import styled from 'styled-components/macro';

import * as colors from 'components/common/colorConstants';

export const modalStyles = {
  overlay: {
    backgroundColor: colors.darkOverlay,
    zIndex: 1000,
  },
  content: {
    border: `1px solid ${colors.lightGray13}`,
    boxSizing: 'border-box',
    boxShadow: `0px 20px 35px ${colors.blackTransparent}`,
    width: '90%',
    maxWidth: '802px',
    height: '670px',
    padding: 0,
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
  },
};

export const ModalHeader = styled.div`
  border-bottom: 2px solid ${colors.lightGray6};
  display: flex;
  align-items: center;
  height: 48px;
  padding: 0 16px;
`;

export const SenderInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 12px;

  & .message-time {
    margin: 0;
  }
`;

export const CloseButton = styled.button`
  border: 0;
  background: transparent;
  color: ${colors.lightGray2};
  font: 300 18px 'Roboto', sans-serif;
  padding: 0;
  margin-left: auto;

  &:hover {
    color: ${colors.darkGray2};
  }
`;

export const ContentWrapper = styled.div`
  padding: 24px 24px 20px;
`;

export const LargeImageContainer = styled.div`
  background: ${colors.lightGray7};
  width: 100%;
  height: 482px;
  margin-bottom: 20px;
  text-align: center;

  & > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
